import { createContext } from 'react';
import type { SessionContextValue } from './session';

/* The context object, kept out of the module that changes.
   -----------------------------------------------------------------------------
   A context is matched by object identity, and session.tsx imports supabase,
   push, policy and boot — four files that are edited often. In development each
   of those edits re-evaluates session.tsx, which used to make a new context
   while the mounted provider went on handing out the old one, and every screen
   below it would throw "useSession must be used inside <SessionProvider>" with
   the provider present and correct.

   src/core/i18nContext.ts explains the mechanism in full; it is where this was
   found, from a real report filed against /attendance.

   The type import is erased before anything runs, so there is no cycle. */
export const SessionContext = createContext<SessionContextValue | null>(null);
